import { fetchWithAuth } from './fetchWithAuth';

export async function updateGroupChatStatus(applicantId: string, brandId: string, orgId: string, created: boolean, token: string) {
  return fetchWithAuth(`/api/organizations/${orgId}/brands/${brandId}/applicants/${applicantId}/group-chat`, {
    method: 'PUT',
    body: JSON.stringify({ created }),
    token
  });
}
